import { routesPath } from '../constants/routesPath';

export const buildInternalSsoHandoffUrl = (targetUrl, code) => {
  if (!targetUrl || !/^[a-f0-9]{64}$/i.test(code || '')) {
    throw new Error('The SSO handoff response is invalid.');
  }

  const handoffUrl = new URL(routesPath.internalSso, targetUrl);
  handoffUrl.search = '';
  handoffUrl.hash = new URLSearchParams({ code }).toString();
  return handoffUrl.toString();
};

export const getSafeInternalReturnPath = (returnPath) => {
  if (
    typeof returnPath !== 'string' ||
    !returnPath.startsWith('/') ||
    returnPath.startsWith('//') ||
    returnPath.includes('\\')
  ) {
    return routesPath.dashboard;
  }

  return returnPath;
};
